module.exports = __webpack_public_path__ + "img/ic-acessibilidade-diminuir-texto-ac.3697858a.svg";